import React from 'react';
import { oneOfType, string, number, func, bool } from 'prop-types';
import CustomControl from '../CustomControl/CustomControl';

const propTypes = {
  id: oneOfType([string, number]).isRequired,
  name: string.isRequired,
  title: string.isRequired,
  value: oneOfType([string, number]).isRequired,
  onChange: func.isRequired,
  checked: bool.isRequired,
};

const defaultProps = {
  onChange() {},
  checked: false,
};

const ListItemControl = ({ id, name, value, onChange, title, checked }) => (
  <CustomControl
    className="custom-control-xs"
    id={id}
    name={name}
    value={value}
    onChange={onChange}
    label={title}
    checked={checked}
  />
);

ListItemControl.propTypes = propTypes;
ListItemControl.defaultProps = defaultProps;

export default ListItemControl;
